import type { QuestionnaireResponse } from '../types';

/**
 * Transforms form data into the questionnaire response format expected by the API
 */
function transformQuestionnaireData(formValues: Record<string, string>, questionsData: Record<string, string>, dialogId: string): QuestionnaireResponse {
  const questionnaireResponse: Record<
    string,
    {
      value: string;
      labelQuestion: string;
      labelOption: string;
    }
  > = {};

  // Map form field names to question numbers
  const fieldToQuestionMap = {
    statement: '1',
    occupation: '2',
    industry: '3',
    pay: '4',
    spend: '5',
  } as const;

  // Transform each form field - form values are already the API option keys
  Object.entries(fieldToQuestionMap).forEach(([fieldName, questionNumber]) => {
    const optionKey = formValues[fieldName];
    if (optionKey) {
      // Get question text based on question number
      const questionKey = `question${questionNumber}` as keyof typeof questionsData;
      const questionText = questionsData[questionKey] || '';

      // Get option text using the option key directly
      const optionText = questionsData[optionKey as keyof typeof questionsData] || '';

      questionnaireResponse[questionNumber] = {
        value: optionKey,
        labelQuestion: questionText,
        labelOption: optionText,
      };
    }
  });

  return {
    id: dialogId,
    questionnaireResponse,
  };
}

export { transformQuestionnaireData };
